import React, { useMemo } from 'react';
import { replace } from 'connected-react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { SubscriptionCompletedModal } from './SubscriptionCompletedModal';
import { SubscriptionRejectedModal } from './SubscriptionRejectedModal';

import { get } from '../../utils/lodash';
import { selectLocation } from '../../global-selectors';
import { selectCurrentContentFichaPath } from '../../queries/selectors/contents';


const withPaymentStatus = (WrappedComponent) => (props) => {
  const Wrapper = (innerProps) => {
    const { location, replace, path } = innerProps;
    const showSubscriptionCompletedModal = useMemo(() => Boolean(get(location, 'state.showSubscriptionCompletedModal')), [location]);
    const showSubscriptionRejectedModal = useMemo(() => Boolean(get(location, 'state.showSubscriptionRejectedModal')), [location]);

    const handleSubscriptionCompletedModalClose = () => {
      const { state = {} } = location;
      delete state.showSubscriptionCompletedModal;
      replace({ ...location, state });
      window.location.replace(path);
    };

    const handleSubscriptionRejectedModalClose = () => {
      const { state = {} } = location;
      delete state.showSubscriptionRejectedModal;
      replace({ ...location, state });
    };

    return (
      <React.Fragment>
        <SubscriptionCompletedModal
          open={showSubscriptionCompletedModal}
          onToggle={handleSubscriptionCompletedModalClose}
        />

        <SubscriptionRejectedModal
          open={showSubscriptionRejectedModal}
          onToggle={handleSubscriptionRejectedModalClose}
        />

        <WrappedComponent {...innerProps} />
      </React.Fragment>
    )
  };

  Wrapper.propTypes = {
    path: PropTypes.string.isRequired,
    replace: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string,
      state: PropTypes.shape({
        showSubscriptionCompletedModal: PropTypes.bool,
        showSubscriptionRejectedModal: PropTypes.bool,
      }),
    }).isRequired,
  };

  return Wrapper(props);
};

const mapStateToProps = (state) => ({
  location: selectLocation(state),
  path: selectCurrentContentFichaPath(state)
});

const mapDispatchToProps = {
  replace
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withPaymentStatus
);
